/**
 * Shared enums and DTOs used by both the API and the web client.
 * Keep these in sync with the Prisma schema.
 */

export const MemberStatus = {
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  APPROVED_UNPAID: "APPROVED_UNPAID",
  ACTIVE: "ACTIVE",
  LAPSED: "LAPSED",
} as const;
export type MemberStatus = (typeof MemberStatus)[keyof typeof MemberStatus];

export const UserRole = {
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const BookBucket = {
  CURRENT: "CURRENT",
  UP_NEXT: "UP_NEXT",
  PAST: "PAST",
} as const;
export type BookBucket = (typeof BookBucket)[keyof typeof BookBucket];

export const LocationBucket = {
  MANTECA: "MANTECA",
  AREA_209: "AREA_209",
  FARTHER_OUT: "FARTHER_OUT",
} as const;
export type LocationBucket = (typeof LocationBucket)[keyof typeof LocationBucket];

export const Genre = {
  ROMANCE: "ROMANCE",
  THRILLER_MYSTERY: "THRILLER_MYSTERY",
  LITERARY_FICTION: "LITERARY_FICTION",
  FANTASY_SCIFI: "FANTASY_SCIFI",
  MEMOIR_NONFICTION: "MEMOIR_NONFICTION",
  YA: "YA",
  HISTORICAL_FICTION: "HISTORICAL_FICTION",
  HORROR: "HORROR",
  ANYTHING: "ANYTHING",
} as const;
export type Genre = (typeof Genre)[keyof typeof Genre];

export const GenreLabels: Record<Genre, string> = {
  ROMANCE: "Romance",
  THRILLER_MYSTERY: "Thriller / Mystery",
  LITERARY_FICTION: "Literary Fiction",
  FANTASY_SCIFI: "Fantasy / Sci-Fi",
  MEMOIR_NONFICTION: "Memoir / Nonfiction",
  YA: "YA",
  HISTORICAL_FICTION: "Historical Fiction",
  HORROR: "Horror",
  ANYTHING: "I'll read anything",
};

export const LocationLabels: Record<LocationBucket, string> = {
  MANTECA: "Manteca",
  AREA_209: "Elsewhere in the 209",
  FARTHER_OUT: "Farther out",
};
